import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function deleteAdministrativeCenter (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      const data = mock.getLocations
      const pages = data.data.length

      const clone = JSON.parse(JSON.stringify(data))
      clone.meta.total = pages

      resolve(clone)
    })
  } else {
    const req = {
      url: '/api/sociedad/deleteCentroAdministrativo',
      method: 'DELETE',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data: params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { deleteAdministrativeCenter }
